// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"5b9f9e93","648":"2b4ce5f4"}[chunkId] + ".chunk.js";
};